import { FetchSeatsInventoryRequestTypes } from '../actions/SeatsInventoryActions';
const initialState = {
  paidSeats: [],
  trialSeats: []
};
const SeatsInventory = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchSeatsInventoryRequestTypes.RECEIVE:
      {
        const {
          data
        } = payload;
        return data;
      }
    default:
      return state;
  }
};
export default SeatsInventory;